module.exports = __webpack_public_path__ + "Common Style Files/img/ALK_Logo.91a12972d5b8554b0732fc45a8d2aa6a.png";


//////////////////
// WEBPACK FOOTER
// ./Common Style Files/img/ALK_Logo.png
// module id = 110
// module chunks = 1 3